import {
  useCallback, useEffect, useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, batch } from 'react-redux';
import debounce from 'lodash/debounce';
import { resetFilteredBoothIds } from 'models/cms/booths';
import { setSelectedCategoryIds } from 'models/cms/boothTaxonomies';

const useFilter = () => {
  const dispatch = useDispatch();
  const [selectedFilter, setSelectedFilter] = useState(() => {
    try {
      const { searchParams } = new URL(window.location.href);
      const fromStorage = JSON.parse(searchParams.get('boothFilter') || localStorage.getItem('boothFilter'));
      if (!Array.isArray(fromStorage)) return [];
      return fromStorage || [];
    } catch {
      return [];
    }
  });
  const history = useHistory();

  const updateCategoryFilterState = (selectedIds) => {
    batch(() => {
      dispatch(setSelectedCategoryIds(selectedIds));
      dispatch(resetFilteredBoothIds());
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateCategoryFilterStateWithDebounce = useCallback(
    debounce(updateCategoryFilterState, 1000, { leading: true }),
    [],
  );

  useEffect(() => {
    localStorage.setItem('boothFilter', JSON.stringify(selectedFilter));
    history.push({
      search: `?boothFilter=${JSON.stringify(selectedFilter)}`,
    });
    updateCategoryFilterStateWithDebounce(selectedFilter);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter]);

  const resetSelectedFilter = useCallback(() => {
    setSelectedFilter([]);
  }, []);

  return {
    selectedFilter,
    setSelectedFilter,
    resetSelectedFilter,
    subLevelOnClick: () => null,
    onClick: () => null,
  };
};

export default useFilter;
